import React from 'react';
export const TestimonialSection = () => {
  return <div className="bg-white py-8" data-id="element-359">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-360">
        <h2 className="text-2xl md:text-3xl font-bold text-[#3885B2] mb-6" data-id="element-361">
          Inne Kobiety, Podobne Historie
        </h2>
        <p className="text-lg mb-6" data-id="element-362">
          Historia Ewy nie jest odosobniona. Oto co mówią inne Polki:
        </p>
        <div className="space-y-6 mb-8" data-id="element-363">
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-364">
            <div className="flex items-start" data-id="element-365">
              <div className="mr-4" data-id="element-366">
                <img src="https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=100&auto=format&fit=crop" alt="Małgorzata" className="w-16 h-16 rounded-full object-cover" data-id="element-367" />
              </div>
              <div data-id="element-368">
                <h4 className="font-bold" data-id="element-369">Małgorzata, 49 lat, Gdańsk:</h4>
                <p className="italic" data-id="element-370">
                  "Mój ginekolog nalegał na hormony. Bałam się skutków
                  ubocznych. Probiotyki dały mi to, czego szukałam - bez ryzyka.
                  6 kilogramów mniej, koniec z uciążliwymi uderzeniami gorąca."
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-371">
            <div className="flex items-start" data-id="element-372">
              <div className="mr-4" data-id="element-373">
                <img src="https://images.unsplash.com/photo-1569124589354-615739ae007b?q=80&w=100&auto=format&fit=crop" alt="Beata" className="w-16 h-16 rounded-full object-cover" data-id="element-374" />
              </div>
              <div data-id="element-375">
                <h4 className="font-bold" data-id="element-376">Beata, 54 lata, Warszawa:</h4>
                <p className="italic" data-id="element-377">
                  "Przytyłam 15 kg po menopauzie. Czułam się jak baleron. Po 4
                  miesiącach - minus 9 kg, mąż mówi, że wyglądam o 10 lat
                  młodziej. Najważniejsze - czuję się jak dawniej."
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-378">
            <div className="flex items-start" data-id="element-379">
              <div className="mr-4" data-id="element-380">
                <img src="https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?q=80&w=100&auto=format&fit=crop" alt="Agnieszka" className="w-16 h-16 rounded-full object-cover" data-id="element-381" />
              </div>
              <div data-id="element-382">
                <h4 className="font-bold" data-id="element-383">Agnieszka, 51 lat, Wrocław:</h4>
                <p className="italic" data-id="element-384">
                  "Bezsenność niszczyła mi życie. Każdej nocy budziłam się 3-4
                  razy oblana potem. Teraz śpię jak niemowlę. Mam energię,
                  jakiej nie miałam od lat."
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-385">
            <div className="flex items-start" data-id="element-386">
              <div className="mr-4" data-id="element-387">
                <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=100&auto=format&fit=crop" alt="Dr Katarzyna Kowalska" className="w-16 h-16 rounded-full object-cover" data-id="element-388" />
              </div>
              <div data-id="element-389">
                <h4 className="font-bold" data-id="element-390">Dr Katarzyna Kowalska, ginekolog:</h4>
                <p className="italic" data-id="element-391">
                  "Początkowo byłam sceptyczna wobec 'naturalnych' rozwiązań.
                  Ale wyniki, które widzę u pacjentek stosujących probiotyki
                  jelitowe, zmusiły mnie do przewartościowania poglądów. Teraz
                  to pierwsza rzecz, którą polecam przed rozważeniem terapii
                  hormonalnej."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};